import * as React from 'react';

type UseSingleDateValueParams = {
  value?: Date;
  defaultValue?: Date;
  onChange?: (value: Date | undefined, name?: string) => void;
  name?: string;
};

const getDateKey = (date: Date | undefined) => date?.getTime() ?? '';

export function useSingleDateValue({
  value: externalValue,
  defaultValue,
  onChange,
  name,
}: UseSingleDateValueParams) {
  const isControlled = externalValue !== undefined;
  const [draft, setDraft] = React.useState<Date | undefined>(
    isControlled ? externalValue : defaultValue,
  );
  const lastExternalKeyRef = React.useRef(getDateKey(externalValue));

  if (isControlled) {
    const externalKey = getDateKey(externalValue);
    if (externalKey !== lastExternalKeyRef.current) {
      lastExternalKeyRef.current = externalKey;
      setDraft(externalValue);
    }
  }

  const commit = React.useCallback(
    (next: Date | undefined) => {
      setDraft(next);
      onChange?.(next, name);
    },
    [name, onChange],
  );

  return {value: draft, commit};
}
